import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-lease-selector',
  templateUrl: './lease-selector.component.html',
  styleUrls: ['./lease-selector.component.scss']
})
export class LeaseSelectorComponent {
  @Input() leases: any[] = [];
  @Output() onCancel = new EventEmitter<void>();

  cancel() {
    this.onCancel.emit();
  }
}
